import React, { useState } from "react";
import PropTypes from "prop-types";
import { BLUEPRINTS_CONFIG } from "constants/index";
import Expandable from "components/Expandable";
import Tags, { TAG_SIZE } from "components/Tags";

/**
 * BlueprintSummaryTags
 *
 * A blueprint's tags, cut to the first few with a show more / show less toggle when there are more.
 *
 * @param {Array}  tags  The disciplines or skills to show
 */
const BlueprintSummaryTags = ({ tags, ...props }) => {
  const [expanded, setExpanded] = useState(false);
  const limit = expanded ? tags.length : BLUEPRINTS_CONFIG.SUMMARY_TAGS_LIMIT;

  return (
    <>
      <Tags data={tags} limit={limit} size={TAG_SIZE.small} hideOverflowCount {...props} />
      {tags.length > BLUEPRINTS_CONFIG.SUMMARY_TAGS_LIMIT && <Expandable onToggle={setExpanded} />}
    </>
  );
};

BlueprintSummaryTags.propTypes = {
  tags: PropTypes.array.isRequired,
};

export default BlueprintSummaryTags;
